import axiosInstance from "../../axiosInstance";

const BASE = "/reports/finance";

export const getFinanceCashflowReport = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE}/cashflow`, { params });
  return res.data;
};

export const getFinanceCollectionsReport = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE}/collections`, { params });
  return res.data;
};
